// Generated, DO NOT EDIT MANUALLY.
import { createTypedClient } from '../../../pplx/frontend/api-clients/core/client.js';
export const pinsClient = createTypedClient();
export const createPinsClient = (config) => createTypedClient(config);
